import * as React from 'react';
import {useContext, useEffect, useState} from 'react';
import {DefaultButton, Dropdown, Panel, PrimaryButton, Stack} from '@fluentui/react';
import AuthContext from "../../Services/AuthContext";

function GenerateProjectDocument(props) {
    const [user] = useContext(AuthContext);
    const [type, setType] = useState(null);
    const [types, setTypes] = useState([]);

    const _submit = (e) => {
        e.preventDefault();
        if (type !== null) {
            fetch(`/api/project/${props.add}/template/${type.key}`, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(json => {
                    props.onSuccess(json);
                    props.dismissPanel();
                })
                .catch(err => {
                    console.log(err)
                })
        }
    }

    useEffect(() => {
        const abortController = new AbortController();
        setType(null);
        if (props.add) {
            async function fetchTypes() {
                await fetch(`/api/project/${props.add}/template`, {
                    method: 'GET',
                    signal: abortController.signal,
                    headers: {
                        'Authorization': 'Bearer ' + user.token
                    }
                }).then(res => res.json())
                    .then(data => {
                        setTypes(data.map((item) => {
                            return {key: item.id, text: item.type};
                        }))
                    })
                    .catch(err => {
                        console.log(err)
                    })
            }
            fetchTypes();
        }
        return () => abortController.abort();
    }, [props.add, user.token])

    const footer = React.useCallback(() => (<Stack horizontal horizontalAlign='space-between'>
        <PrimaryButton type='submit' form='GenerateProjectDocument'>Dodaj</PrimaryButton>
        <DefaultButton onClick={props.dismissPanel}>Anuluj</DefaultButton>
    </Stack>), [props.dismissPanel]);


    return (
        <Panel
            isOpen={props.add}
            onDismiss={props.dismissPanel}
            headerText="Generuj Dokument"
            closeButtonAriaLabel="Close"
            onRenderFooterContent={footer}
            isFooterAtBottom={true}
        >
            <form onSubmit={_submit} id='GenerateProjectDocument'>
                <Dropdown
                    label="Typ"
                    selectedKey={type ? type.key : undefined}
                    onChange={(e, item) => setType(item)}
                    placeholder="Wybierz z listy"
                    options={types}
                />
            </form>
        </Panel>
    )
}

export default GenerateProjectDocument;